module.exports = __webpack_public_path__ + "assets/images/jefRobinson1.1d9cbc15.jpg";